import { ListParams } from '../types/pagination'

import { http } from '@/app/lib/http/client'

export interface Sucursal {
    id: number
    company_id: number
    name: string
    code: string
    address: string | null
    phone_number: string | null
    email: string | null
    weekday_hours: string | null
    weekend_hours: string | null
    saturday_closed: boolean
    sunday_closed: boolean
    is_active: boolean
    created_at: string
}

export interface CreateSucursalPayload {
    company_id: number
    name: string
    address: string | null
    phone_number: string | null
    email: string | null
    weekday_hours: string | null
    weekend_hours: string | null
    saturday_closed: boolean
    sunday_closed: boolean
    is_active: boolean
}

export interface UpdateSucursalPayload {
    name?: string
    address?: string | null
    phone_number?: string | null
    email?: string | null
    weekday_hours?: string | null
    weekend_hours?: string | null
    saturday_closed?: boolean
    sunday_closed?: boolean
    is_active?: boolean
}

export const sucursalService = {
    async getSucursales(params?: ListParams & { company_id?: number }) {
        const response = await http.get('/sucursales', { params })
        return response.data
    },

    async getSucursal(id: number) {
        const response = await http.get(`/sucursales/${id}`)
        return response.data
    },

    async createSucursal(payload: CreateSucursalPayload) {
        const response = await http.post('/sucursales', payload)
        return response.data
    },

    async updateSucursal(id: number, payload: UpdateSucursalPayload) {
        const response = await http.patch(`/sucursales/${id}`, payload)
        return response.data
    },

    async deleteSucursal(id: number) {
        const response = await http.delete(`/sucursales/${id}`)
        return response.data
    },
}
